import { AnalyticsEvent } from '../../../../analytics/events/analytics.event'
import { PDFType } from '../../../enums/pdf-type'

export class DownloadEvent extends AnalyticsEvent {

  constructor (eventAction = '', eventLabel = '') {
    super('Download', 'Download', DownloadEvent.getAssetType(eventAction, eventLabel), eventLabel)
  }

  private static getAssetType (eventAction: string, eventLabel: string): string {

    if (eventLabel === 'MACSQuant X Flow Cytometer - High-throughput cell analysis at your bench top') {
      eventAction = 'Brochure The MACSQuant X'
      return eventAction
    } else if (eventLabel === 'MACSQuant X specification sheet') {
      eventAction = 'MACSQuant X Instrument specifications'
      return eventAction
    }
    switch (eventAction) {
      case PDFType.DATASHEET: {
        return 'Data sheets'
      }
      case PDFType.BROCHURE: {
        return 'Brochures/posters'
      }
      case PDFType.REFERENCE_LIST: {
        return 'References'
      }
      case PDFType.SCIENTIFIC_POSTER: {
        return 'Scientific posters'
      }
      case PDFType.APP_NOTE: {
        return 'App notes/customer reports'
      }
      case PDFType.DOWNLOAD: {
        return 'Other downloads'
      }
      default:
        return eventAction || 'PDF'
    }
  }
}
